/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Reporting frequency options */
export enum ReportingFrequency {
  Daily,
  Weekly,
  Monthly,
  Quarterly,
  Annually,
  OnDemand,
}

export type ReportingFrequencyArgs = ReportingFrequency;

export function getReportingFrequencyEncoder(): FixedSizeEncoder<ReportingFrequencyArgs> {
  return getEnumEncoder(ReportingFrequency);
}

export function getReportingFrequencyDecoder(): FixedSizeDecoder<ReportingFrequency> {
  return getEnumDecoder(ReportingFrequency);
}

export function getReportingFrequencyCodec(): FixedSizeCodec<
  ReportingFrequencyArgs,
  ReportingFrequency
> {
  return combineCodec(
    getReportingFrequencyEncoder(),
    getReportingFrequencyDecoder(),
  );
}
